import React, {Component} from 'react'
import {Row, Col, Icon} from 'antd'
import axios from 'axios'
import Footer from 'components/Footer'

import 'styles/service.css'

class Service extends Component {
  constructor() {
    super();
    this.state = {
      list: [
        {
          'title': '政府服务',
          'children': [
            {
              'title': '政府公告',
              'src': 'government_1'
            },
            {
              'title': '政策宣传',
              'src': 'government_2'
            },
            {
              'title': '居民意见',
              'src': 'government_3'
            },
            {
              'title': '办事指南',
              'src': 'government_4'
            },
            {
              'title': '社区党建',
              'src': 'government_5'
            },
            {
              'title': '就业创业',
              'src': 'government_4'
            }
          ]
        },
        {
          'title': '生活服务',
          'children': [
            {
              'title': '小区公告',
              'src': 'life_1'
            },
            {
              'title': '缴费管理',
              'src': 'life_2'
            },
            {
              'title': '家政服务',
              'src': 'life_3'
            },
            {
              'title': '物业服务',
              'src': 'life_4'
            },
            {
              'title': '快递服务',
              'src': 'life_5'
            },
            {
              'title': '房屋出租',
              'src': 'life_6'
            },
            {
              'title': '洗衣店',
              'src': 'life_7'
            },
            {
              'title': '便民电话',
              'src': 'life_8'
            },
            {
              'title': '二手物品',
              'src': 'life_9'
            },
            {
              'title': '店铺申请',
              'src': 'life_10'
            }
          ]
        }
      ]
      // list: []
    }
  }

  componentDidMount() {
    // this.ajaxData();
  }

  render() {
    let that = this;
    return (
      <div className='container'>
        <div className='top-box'>
          <a href='#/homePage'>
            <Icon type='left'/>
            <span>服务</span>
          </a>
        </div>
        <div className='service content-main'>
          <div className='service-box'>
            {
              this.state.list.map((item, index) => {
                return (
                  <Row key={index}>
                    <h1>{item.title}</h1>
                    {
                      item.children.map((itemObj, itemIndex) => {
                        return (
                          <Col onClick={this.handleClick.bind(that, event)} className={that.handleClass(itemIndex + 1)}
                               span={6} key={itemIndex}>
                            <img src={'images/service/' + itemObj.src + '.jpg'} alt={itemObj.title}/>
                            <p>{itemObj.title}</p>
                          </Col>
                        )
                      })
                    }
                    <Col onClick={this.handleClick.bind(that, event)}
                         className={that.handleClass(item.children.length + 1)}
                         span={6}>
                      <a href='#/list'>
                        <img className='more' src={'images/service/more.jpg'} alt='更多'/>
                        <p>更多服务</p>
                      </a>
                    </Col>
                  </Row>
                )
              })
            }
          </div>
        </div>
        <Footer/>
      </div>
    )
  }

  ajaxData() {
    let that = this;
    axios.get('api/service.json', {}).then(response => {
      if (response.data.success === 0) {
        that.setState({
          list: response.data.data
        })
      }
    })
  }

  handleClass(index) {
    let className = 'service-item';
    if (index % 4 === 0 && index !== 1) {
      className += ' no-right';
    }
    return className;
  }

  handleClick(target, event) {
    alert('你当前点击的服务是' + event.currentTarget.innerText);
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/pages/service.js